var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Wp_nav_bar',{attrs:{"title":"我的推广预估收入详情"}}),_c('Wp_order_count_self_detail_model')],1)}
var staticRenderFns = []

export { render, staticRenderFns }